module.exports = __webpack_public_path__ + "img/change-bus.8e3f9731.svg";